import { useTranslation } from "react-i18next"
import { useForm } from "react-hook-form"
import { NavLink } from "react-router-dom"
import { Button } from "components/Form/Button"
import { Input } from "components/Form/Input"
import { Textarea } from "components/Form/Textarea"
import { CheckBox } from "components/Form/CheckBox"
import { sendMessage } from "services/api.message"

import Check from "assets/Circle-check.svg"

export const ContactEditFormComponent = () => {
  const {
    register,
    handleSubmit,
    setError,
    formState: {
      errors,
      isSubmitSuccessful
    }
  } = useForm<{
      messageSenderName: string;
      messageSenderContactEmailAddress: string;
      message: string;
      messagePolicy: boolean;
      messageCopy: boolean;
    }
  >({
      defaultValues: {
        messageCopy: true
      }
    }
  )

  const { t } = useTranslation("Contact")

  const onSubmit = (
    message : {
      messageSenderName: string;
      messageSenderContactEmailAddress: string;
      message: string;
    }
  ) => {
    return sendMessage(message)

    .catch(
      (x) => setError(
        "root", { type: "server", message: x }
      )
    )
  }

  return (
    <>
      <form className="flex flex-col gap-y-6"
        onSubmit={
          handleSubmit(onSubmit)
        }
      >
        <Input type={"text"} label={t("Form.Imię")} placeholder={t("Form.Wpisz imię")} errorMessage={errors.messageSenderName?.message}
          {...register("messageSenderName", {
                required: t("Form.Uzupełnij imię")
              }
            )
          }
        />

        <Input type={"email"} label={t("Form.Email")} placeholder={t("Form.Wpisz adres e-mail")} errorMessage={errors.messageSenderContactEmailAddress?.message}
          {...register("messageSenderContactEmailAddress", {
                required: t("Form.Uzupełnij adres e-mail")
              }
            )
          }
        />

        <Textarea label={t("Form.Wiadomość")} placeholder={t("Form.Wpisz wiadomość")} errorMessage={errors.message?.message}
          {...register("message", {
                required: t("Form.Uzupełnij wiadomość")
              }
            )
          }
        />

        <CheckBox errorMessage={errors.messagePolicy?.message}
          label={(
              <>
                {t("Form.Wyrażam zgodę na przetwarzanie danych osobowych w celu udzielenia odpowiedzi na przesłane zapytanie.")} <NavLink to="/polityka-prywatnosci" className="underline">Polityka prywatności</NavLink>
              </>
            )
          }
          {...register("messagePolicy", {
                required: t("Form.Wyraź zgodę na przetwarzanie danych")
              }
            )
          }
          value={"true"}
        />

        <CheckBox errorMessage={errors.messageCopy?.message}
          label={(
              <>
                {t("Form.Chcę otrzymać kopię wysyłanej wiadomości na podany adres e-mail.")}
              </>
            )
          }
          {...register("messageCopy"
            )
          }
          value={"true"}
        />

        {isSubmitSuccessful ? (
          <div className="flex flex-row gap-x-2">
            <img className="min-w-6 min-h-6 max-w-6 max-h-6" src={Check} /> <span className="font-head font-medium text-xl text-aluprofil-gray">{t("Form:Otrzymaliśmy Twoją wiadomość")}</span>
          </div>
        ) : (
          <div className="flex flex-row gap-x-2">
            <Button type={"submit"} errorMessage={errors.root?.message}>
              {t("Form.Wyślij wiadomość")}
            </Button>
          </div>
        )}
      </form>
    </>
  )
}
